import { render, staticRenderFns } from "./KioskModeDisable.vue?vue&type=template&id=4e6a27d2&scoped=true"
import script from "./KioskModeDisable.vue?vue&type=script&lang=ts"
export * from "./KioskModeDisable.vue?vue&type=script&lang=ts"
import style0 from "./KioskModeDisable.vue?vue&type=style&index=0&id=4e6a27d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6a27d2",
  null
  
)

export default component.exports